// extracted by mini-css-extract-plugin
export default {"trade":"Trade_trade__zkNtp","bg_shadow":"Trade_bg_shadow__5EAX1","credit_container":"Trade_credit_container__hE8hC","trade_box":"Trade_trade_box__r2M-I"};